import { Calculator } from '@dynameat/views/reporting/models/calculator';
import { AVERAGE_DINER_TIME } from '../../constants';
import { AverageDinerTimeQuery } from '../queries';

export class AverageDinerTimeCalculator extends Calculator {
  kpiType = AVERAGE_DINER_TIME

  async calculateKPI() {
    const currentResponse = await this.executeUncubeQuery(AverageDinerTimeQuery, this.currentPeriod);
    let props;
    if (this.previousPeriod) {
      const previousResponse = await this.executeUncubeQuery(AverageDinerTimeQuery, this.previousPeriod);
      props = this.getData(currentResponse.data.result[0][0] / (60 * currentResponse.data.result[0][1]), previousResponse.data.result[0][0] / (60 * previousResponse.data.result[0][1]));
    } else props = this.getDataIfNoPreviousPeriod(currentResponse.data.result[0][0] / (60 * currentResponse.data.result[0][1]));
    return this.getModelToInstance(props);
  }

  getValueOfKpi(rawKpi) {
    if (!Number.isNaN(rawKpi)) {
      return Math.trunc(rawKpi * 100) / 100;
    }
    return 0;
  }
}
